/* eslint-disable no-alert */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Box, List, Drawer, Button, Divider, CircularProgress } from '@mui/material';
import { useQuery, useParameterizedQuery, useMutation } from 'react-fetching-library';
import { useSelector, useDispatch } from 'react-redux';

import { useResponsive } from '../../../services/hooks';
import { NAVBAR } from '../../../utils/config';
import Iconify from '../../../components-core/Iconify';
import Scrollbar from '../../../components-core/Scrollbar';
import { getPredefinedFilters, getModuleViewsAction, updateEmployeeConfigAction, monthDay1Test, monthDay1TestSendMails, monthDay6Test } from '../../../services/request';
import { setOrderFilters } from '../../../services/redux-actions';
import { CircularProgressContainer } from '../../../components-core/others/CircularProgressContainer';
import { DialogAnimate } from '../../../components-core/animate';
import { ViewForm } from './ViewForm';
import { FilterTree } from './FilterTree';
import { ViewList } from './ViewList';
import SendMessage from './SendMessage';
import RefreshIcon from '@mui/icons-material/Refresh';
import GenerateSpreadsheet from './GenerateSpreadsheet';

export default function OrderSidebar({ isOpenSidebar, onCloseSidebar, idList, setIdList, ordersDataForMessages, refreshOrders }) {
  const filtersRef = React.useRef();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { season, module, employeeId, employeeConfigId } = useSelector(state => state.app);
  const { orderFilters } = useSelector(state => state.employeeOrderConfig);
  const { loading, payload, error } = useQuery(getPredefinedFilters(season));
  const { query: day1Query, loading: day1Loading } = useParameterizedQuery(monthDay1Test);
  const { query: day1SendMailQuery, loading: sendLoading } = useParameterizedQuery(monthDay1TestSendMails);
  const { query: day6Query } = useParameterizedQuery(monthDay6Test);
  const { mutate } = useMutation(updateEmployeeConfigAction);
  const moduleViewsQuery = useQuery(getModuleViewsAction(module));
  const isDesktop = useResponsive('up', 'md');
  const [predefinedFilters, setPredefinedFilters] = React.useState({});
  const [moduleViews, setModuleViews] = React.useState([]);
  const [isOpenViewModal, setIsOpenViewModal] = React.useState(false);

  const day1Click = async () => {
    const { payload } = await day1Query();
    console.log(payload);
    if (!error) {
      alert('płatności zostały wygenerowane');
    } else {
      alert('nie udało się wygenerować płatności');
    }
  };

  const day1SendMailClick = async () => {
    const { error, payload } = await day1SendMailQuery();
    console.log(payload);
    if (!error) {
      alert('maile zostały wysłane');
    } else {
      alert('nie udało się wysłać maili');
    }
  };

  const day6Click = async () => {
    const { payload } = await day6Query();
    console.log(payload);
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setPredefinedFilters(payload);
    }
  }, [loading, season]);

  React.useEffect(() => {
    if (!moduleViewsQuery.error && !moduleViewsQuery.loading) {
      setModuleViews(moduleViewsQuery.payload.results);
    }
  }, [moduleViewsQuery.loading, module]);

  React.useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  const handleApplyFilters = () => {
    const { payload } = dispatch(setOrderFilters({ [season]: filtersRef.current.getFilters() }));
    refreshOrders();
    // const { error } = await mutate({ order_filters: payload, employee: employeeId }, employeeConfigId);
  };

  const deleteViewCallback = id => {
    setModuleViews(_.filter(moduleViews, obj => obj.id !== id));
  };

  const createViewCallback = view => {
    setModuleViews([view, ...moduleViews]);
  };

  const resetFilters = async () => {
    const { payload } = dispatch(setOrderFilters({ [season]: filtersRef.current.resetFilters() }));
    const { error } = await mutate({ order_filters: payload, employee: employeeId }, employeeConfigId);
  };

  const getViewDataCallback = id => _.filter(moduleViews, obj => obj.id === id)[0];

  const renderContent = (
    <Scrollbar style={{ opacity: loading ? '0.5' : '1' }}>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {/* <Button fullWidth variant="contained" onClick={day1Click} disabled={day1Loading}>Generuj Płatności {day1Loading ? <CircularProgress size={12} /> : null}</Button>
      <Button fullWidth variant="contained" onClick={day1SendMailClick} disabled={sendLoading} sx={{ mt: 2 }}>Wyślij mail {sendLoading ? <CircularProgress size={12} /> : null}</Button> */}
      <List disablePadding>
        {!_.isEmpty(moduleViews)
          ? <ViewList data={moduleViews} deleteViewCallback={deleteViewCallback} getViewDataCallback={getViewDataCallback} commitFiltersCallback={handleApplyFilters} />
          : null
        }
        {!_.isEmpty(predefinedFilters)
          ? <FilterTree data={predefinedFilters} ref={filtersRef} initSelected={orderFilters[season]} />
          : null
        }
      </List>
      <Divider />
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button sx={{ mr: 2 }} fullWidth variant="contained" onClick={handleApplyFilters}>Zastosuj filtry</Button>
        <Button variant="contained" fullWidth onClick={resetFilters}>Zresetuj filtry</Button>
      </Box>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button
          fullWidth
          variant="contained"
          endIcon={<Iconify icon={'eva:save-fill'} />}
          onClick={() => setIsOpenViewModal(true)}
        >
          Zapisz widok
        </Button>
      </Box>
      {/* <GenerateSpreadsheet idList={idList} /> */}
      <SendMessage idList={idList} setIdList={setIdList} ordersDataForMessages={ordersDataForMessages}/>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button variant="contained" fullWidth endIcon={<RefreshIcon />} onClick={refreshOrders}>Odśwież</Button>
      </Box>
    </Scrollbar>
  );

  return (
    <>
      {isDesktop ? (
        <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative' } }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
      <DialogAnimate open={isOpenViewModal} onClose={() => setIsOpenViewModal(false)}>
        <ViewForm closeDialog={() => setIsOpenViewModal(false)} createViewCallback={createViewCallback} />
      </DialogAnimate>
    </>
  );
}

OrderSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onOpenCompose: PropTypes.func,
  onCloseSidebar: PropTypes.func
};
